export const DATE_FORMAT = 'DD/MM/YYYY'
export const DATE_TIME_FORMAT = 'HH:mm DD/MM/YYYY'
export const BILLING_TYPES = {
  document: { value: 'document', label: 'Tài liệu' },
  submission: { value: 'submission', label: 'Hồ sơ' },
  page: { value: 'page', label: 'Trang' },
}
export const DELAY = 800
export const ORG_TYPES = {
  trial: { value: 'trial', label: 'Trial' },
  enterprise: { value: 'enterprise', label: 'Enterprise' },
}
export const LOGIN_TYPES = {
  manual: { value: 'manual', label: 'manual' },
  google: { value: 'google', label: 'google' },
}
export const SUBMISSION_TYPES = {
  insurance: { value: 'insurance', label: 'insurance' },
  invoice: { value: 'invoice', label: 'invoice' },
  invoice_vehicle: { value: 'invoice_vehicle', label: 'invoice_vehicle' },
  hr: { value: 'hr', label: 'hr' },
  business: { value: 'business', label: 'business' },
  birth_certificate: { value: 'birth_certificate', label: 'birth_certificate' },
  vehicle_document: { value: 'vehicle_document', label: 'vehicle_document' },
  identification_document: { value: 'identification_document', label: 'identification_document' },
  finance: { value: 'finance', label: 'finance' },
  finance_bank: { value: 'finance_bank', label: 'finance_bank' },
  financetcb: { value: 'financetcb', label: 'financetcb' },
  general_table: { value: 'general_table', label: 'general_table' },
  statement: { value: 'statement', label: 'statement' },
  vehicle_quotation: { value: 'vehicle_quotation', label: 'vehicle_quotation' },
  credit_report: { value: 'credit_report', label: 'credit_report' },
  bond_records: { value: 'bond_records', label: 'bond_records' },
  bond_records_ha: { value: 'bond_records_ha', label: 'bond_records_ha' },
  vehicle_registration: { value: 'vehicle_registration', label: 'vehicle_registration' },
  civil_registration: { value: 'civil_registration', label: 'civil_registration' },
  laborer_info: { value: 'laborer_info', label: 'laborer_info' },
  publish_license: { value: 'publish_license', label: 'publish_license' },
  loan_proposal: { value: 'loan_proposal', label: 'loan_proposal' },
  custom_document: { value: 'custom_document', label: 'custom_document' },
}

// So khai sinh

export const SKS_GIOI_TINH = ['Nam', 'Nữ', 'Không xác định']

export const SKS_DAN_TOC = [
  'Kinh',
  'Tày',
  'Thái',
  'Hoa',
  'Khơ-me',
  'Mường',
  'Nùng',
  'HMông',
  'Dao',
  'Gia-rai',
  'Ngái',
  'Ê-đê',
  'Ba na',
  'Xơ-Đăng',
  'Sán Chay',
  'Cơ-ho',
  'Chăm',
  'Sán Dìu',
  'Hrê',
  'Mnông',
  'Ra-glai',
  'Xtiêng',
  'Bru-Vân Kiều',
  'Thổ',
  'Giáy',
  'Cơ-tu',
  'Gié Triêng',
  'Mạ',
  'Khơ-mú',
  'Co',
  'Tà-ôi',
  'Chơ-ro',
  'Kháng',
  'Xinh-mun',
  'Hà Nhì',
  'Chu ru',
  'Lào',
  'La Chí',
  'La Ha',
  'Phù Lá',
  'La Hủ',
  'Lự',
  'Lô Lô',
  'Chứt',
  'Mảng',
  'Pà Thẻn',
  'Co Lao',
  'Cống',
  'Bố Y',
  'Si La',
  'Pu Péo',
  'Brâu',
  'Ơ Đu',
  'Rơ măm',
  'Người nước ngoài',
  'Không rõ',
]

export const SKS_QUOC_TICH = [
  'Việt Nam',
  'Andorra',
  'United Arab Emirates',
  'Afghanistan',
  'Antigua and Barbuda',
  'Anguilla',
  'Albania',
  'Armenia',
  'Angola',
  'Antarctica',
  'Argentina',
  'American Samoa',
  'Austria',
  'Australia',
  'Aruba',
  'Åland Islands',
  'Azerbaijan',
  'Bosnia and Herzegovina',
  'Barbados',
  'Bangladesh',
  'Belgium',
  'Burkina Faso',
  'Bulgaria',
  'Bahrain',
  'Burundi',
  'Benin',
  'Saint Barthélemy',
  'Bermuda',
  'Brunei Darussalam',
  'Bolivia (Plurinational State of)',
  'Bonaire, Sint Eustatius and Saba',
  'Brazil',
  'Bahamas',
  'Bhutan',
  'Bouvet Island',
  'Botswana',
  'Belarus',
  'Belize',
  'Canada',
  'Cocos (Keeling) Islands',
  'Congo, Democratic Republic of the',
  'Central African Republic',
  'Congo',
  'Switzerland',
  "Côte d'Ivoire",
  'Cook Islands',
  'Chile',
  'Cameroon',
  'China',
  'Colombia',
  'Costa Rica',
  'Cuba',
  'Cabo Verde',
  'Curaçao',
  'Christmas Island',
  'Cyprus',
  'Czechia',
  'Germany',
  'Djibouti',
  'Denmark',
  'Dominica',
  'Dominican Republic',
  'Algeria',
  'Ecuador',
  'Estonia',
  'Egypt',
  'Western Sahara',
  'Eritrea',
  'Spain',
  'Ethiopia',
  'Finland',
  'Fiji',
  'Falkland Islands (Malvinas)',
  'Micronesia (Federated States of)',
  'Faroe Islands',
  'France',
  'Gabon',
  'United Kingdom of Great Britain and Northern Ireland',
  'Grenada',
  'Georgia',
  'French Guiana',
  'Guernsey',
  'Ghana',
  'Gibraltar',
  'Greenland',
  'Gambia',
  'Guinea',
  'Guadeloupe',
  'Equatorial Guinea',
  'Greece',
  'South Georgia and the South Sandwich Islands',
  'Guatemala',
  'Guam',
  'Guinea-Bissau',
  'Guyana',
  'Hong Kong',
  'Heard Island and McDonald Islands',
  'Honduras',
  'Croatia',
  'Haiti',
  'Hungary',
  'Indonesia',
  'Ireland',
  'Israel',
  'Isle of Man',
  'India',
  'British Indian Ocean Territory',
  'Iraq',
  'Iran (Islamic Republic of)',
  'Iceland',
  'Italy',
  'Jersey',
  'Jamaica',
  'Jordan',
  'Japan',
  'Kenya',
  'Kyrgyzstan',
  'Cambodia',
  'Kiribati',
  'Comoros',
  'Saint Kitts and Nevis',
  "Korea (Democratic People's Republic of)",
  'Korea, Republic of',
  'Kuwait',
  'Cayman Islands',
  'Kazakhstan',
  "Lao People's Democratic Republic",
  'Lebanon',
  'Saint Lucia',
  'Liechtenstein',
  'Sri Lanka',
  'Liberia',
  'Lesotho',
  'Lithuania',
  'Luxembourg',
  'Latvia',
  'Libya',
  'Morocco',
  'Monaco',
  'Moldova, Republic of',
  'Montenegro',
  'Saint Martin (French part)',
  'Madagascar',
  'Marshall Islands',
  'North Macedonia',
  'Mali',
  'Myanmar',
  'Mongolia',
  'Macao',
  'Northern Mariana Islands',
  'Martinique',
  'Mauritania',
  'Montserrat',
  'Malta',
  'Mauritius',
  'Maldives',
  'Malawi',
  'Mexico',
  'Malaysia',
  'Mozambique',
  'Namibia',
  'New Caledonia',
  'Niger',
  'Norfolk Island',
  'Nigeria',
  'Nicaragua',
  'Netherlands',
  'Norway',
  'Nepal',
  'Nauru',
  'Niue',
  'New Zealand',
  'Oman',
  'Panama',
  'Peru',
  'French Polynesia',
  'Papua New Guinea',
  'Philippines',
  'Pakistan',
  'Poland',
  'Saint Pierre and Miquelon',
  'Pitcairn',
  'Puerto Rico',
  'Palestine, State of',
  'Portugal',
  'Palau',
  'Paraguay',
  'Qatar',
  'Réunion',
  'Romania',
  'Serbia',
  'Russian Federation',
  'Rwanda',
  'Saudi Arabia',
  'Solomon Islands',
  'Seychelles',
  'Sudan',
  'Sweden',
  'Singapore',
  'Saint Helena, Ascension and Tristan da Cunha',
  'Slovenia',
  'Svalbard and Jan Mayen',
  'Slovakia',
  'Sierra Leone',
  'San Marino',
  'Senegal',
  'Somalia',
  'Suriname',
  'South Sudan',
  'Sao Tome and Principe',
  'El Salvador',
  'Sint Maarten (Dutch part)',
  'Syrian Arab Republic',
  'Eswatini',
  'Turks and Caicos Islands',
  'Chad',
  'French Southern Territories',
  'Togo',
  'Thailand',
  'Tajikistan',
  'Tokelau',
  'Timor-Leste',
  'Turkmenistan',
  'Tunisia',
  'Tonga',
  'Turkey',
  'Trinidad and Tobago',
  'Tuvalu',
  'Taiwan, Province of China',
  'Tanzania, United Republic of',
  'Ukraine',
  'Uganda',
  'United States Minor Outlying Islands',
  'United States of America',
  'Uruguay',
  'Uzbekistan',
  'Holy See',
  'Saint Vincent and the Grenadines',
  'Venezuela (Bolivarian Republic of)',
  'Virgin Islands (British)',
  'Virgin Islands (U.S.)',
  'Viet Nam',
  'Vanuatu',
  'Wallis and Futuna',
  'Samoa',
  'Yemen',
  'Mayotte',
  'South Africa',
  'Zambia',
  'Zimbabwe',
]

export const SKS_LOAI_DANG_KY = [
  'Đăng kí đúng hạn',
  'Đăng kí lại',
  'Ghi vào sổ việc khai sinh đã đăng ký ở CQ có thẩm quyền nước ngoài',
  'Đăng kí quá hạn',
  'Cấp bản chính giấy khai sinh',
]

export const SKT_LOAI_DANG_KY = [
  'Đăng kí đúng hạn',
  'Đăng kí lại',
  'Ghi vào sổ việc khai tử đã được đăng ký tại cơ quan có thẩm quyền của nước ngoài',
  'Đăng kí quá hạn',
]

export const SKH_LOAI_DANG_KY = [
  'Đăng kí lần đầu',
  'Đăng kí lại',
  'Ghi vào sổ việc kết hôn đã được đăng ký tại cơ quan có thẩm quyền ở nước ngoài',
]

export const SKS_LOAI_GTTT = [
  'Giấy CMND',
  'Hộ chiếu',
  'Thẻ thường trú',
  'Thẻ căn cước công dân',
  'Giấy chứng minh quân đội nhân dân',
  'Giấy chứng minh sĩ quan quân đội',
  'Giấy chứng minh công an nhân dân',
  'Giấy tờ khác',
]

export const SKS_ADDRESS_TYPE = {
  1: { value: '1', label: 'Thường trú' },
  2: { value: '2', label: 'Tạm trú' },
  0: { value: '0', label: 'Không có thông tin' },
}

export const PKK_PP_KIEM_TRA = [
  'WEIGHT',
  'ACTUAL'
]

export const PKK_LOAI_KK = [
  'BOX',
  'BAG',
  'PALLET',
  'PILE',
  'ROW',
  'OTHER'
]

export const PKK_DON_VI = [
  'EA',
  'GR',
  'KG',
  'MT',
  'LT',
  'ML'
]

export const YEAR_CATGORIES = ['Thg 1', 'Thg 2', 'Thg 3', 'Thg 4', 'Thg 5', 'Thg 6', 'Thg 7', 'Thg 8', 'Thg 9', 'Thg 10', 'Thg 11', 'Thg 12'];
